import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { baseUrlApi } from "../../proxy";
/*--------------------------GET ALL KORBAS-----------------------------*/
export const getDonationTypes = createAsyncThunk(
  "donationTypes/get-donationTypes",
  async () => {
    try {
      const response = await axios.get(`${baseUrlApi}donation/quick/types`);
      return response?.data;
    } catch (error) {
      throw error;
    }
  }
);

/*--------------------------GET Card Types----------------------------- */
export const getCardTypes = createAsyncThunk(
  "cardTypes/get-cardTypes",
  async () => {
    try {
      const response = await axios.get(`${baseUrlApi}card/types`);
      return response?.data;
    } catch (error) {
      throw error;
    }
  }
);

export const toGetDonationMethods = createAsyncThunk(
  "cardTypes/toGetDonationMethods",
  async () => {
    try {
      const response = await axios.get(`${baseUrlApi}donation_methods`);
      return response?.data;
    } catch (error) {
      throw error;
    }
  }
);
